var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "image" }, [
    !_vm.loaded ? _c("div", { staticClass: "spinner" }) : _vm._e(),
    _vm.loaded
      ? _c("div", { staticClass: "image__wrapper" }, [
          _c("picture", [
            _c("source", {
              attrs: { media: "--small", "data-srcset": _vm.mobileImageId }
            }),
            _c("source", {
              attrs: { media: "--large", "data-srcset": _vm.imageId }
            }),
            _c("img", {
              staticClass: "lazyload",
              attrs: { "data-sizes": "auto", "data-src": _vm.imageId }
            })
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8e8836b0", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e8836b0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/image/image-simple.vue
// module id = 569
// module chunks = 52